import React, { useEffect, useState } from 'react'
import CommonBarChart from '../CommonBarChart'
import Loading from '../Loading'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import { ValidateAPI } from '../../utils/Utils'
import { useNavigate } from 'react-router'
import axiosInstance from '../../api/axiosInstance'

const VendorBarChart = ({ vendor, cpiOffice, supplierId, chartsData }) => {
  const user = JSON.parse(localStorage?.getItem('userData'))
  const [reqTypeData, setReqTypeData] = useState([])
  const [barload, setBarload] = useState(false)
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { DistributionbyRequestType, Norelateddatafound } = t('greeting')
  
  const fetchReqTypeData = () => {
    const vendorURL = `/api/admin/get-all-counts-cr-types-vendor-filter?vendorNumber=${supplierId}`
   
    if ((cpiOffice && vendor) || supplierId) {
      setBarload(true)
      axiosInstance
        .get(vendorURL)
      .then((response) => {
        setReqTypeData(response?.data)
        setBarload(false)
      })
      .catch((error) => {
        if (error.response.status === 401 || error.response.status === 403) {
          navigate('/login-error')
        }
        console.error(error)
        setBarload(false)
      })
    }
  }

  useEffect(() =>{

    if (!chartsData?.requestTypeDistribution) {
      setReqTypeData([]);
      return;
    }
  
    setReqTypeData(chartsData.requestTypeDistribution);
  },[chartsData])

  useEffect(() => {
    if(user?.userGroupName === 'SUPPLIER')
    fetchReqTypeData()
  }, [vendor])
  return (
    <div className="w-[50%] flex justify-center items-center flex-col sm:w-[100%]
    gap-5 shadow-lg rounded-md border border-gray-300 p-3 h-[360px]">
      <p className="text-sm font-medium">{DistributionbyRequestType}</p>
      <div className="relative flex justify-between items-center w-full">
        {!barload ? (
          reqTypeData?.length > 0 ? (
            <CommonBarChart
              chartData={reqTypeData}
              color={'#8884d8'}
              type={'requestType'}
              value={'Count'}
            />
          ) : (
            <div className="flex items-center justify-center w-full h-180">
              <p className="text-m font ">{Norelateddatafound}</p>
            </div>
          )
        ) : (
          <div className='w-full min-h-[250px] justify-center items-center flex'>
            <Loading />
          </div>
        )}
      </div>
    </div>
  )
}

export default VendorBarChart
